module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("For Nancy Eads,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("who has given so much time,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("effort and enthusiasm to")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("being the President of my")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Fan Club")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a307caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0